module.exports = __webpack_public_path__ + "static/scale-model-of-venus-de-milo-statue-in-berkeley-california-641799bd21609189060d62ca056973b2.png";